import OrganisationScene from '../../portal/organisation/users/scenes/OrganisationScene';
import CommunityScene from '../../portal/community/CommunityScene';
import organisationsRoutes from '../../mgmt/organisations/routes';
import communitiesRoutes from '../../mgmt/communities/routes';
import organisationRolesRoutes from '../../mgmt/organisationRoles/routes';
import identificationCodeTypesRoutes from '../../mgmt/identitficationCodeTypes/routes';
import relationTypesRoutes from '../../mgmt/relationTypes/routes';
import appsRoutes from '../../mgmt/apps/routes';
import suiteRoutes from '../../mgmt/suites/routes';
import themeLookupRoutes from '../../mgmt/themeLookups/routes';
import Overview from '../../portal/home/components/Overview';

const routes = [
  {
    title: 'Charts',
    icon: 'home',
    id: 'default',
    routes: [
      {
        path: '/overview',
        component: Overview,
        exact: true,
        menuName: 'home',
        menuIcon: 'home',
        isActiveRoute: currentLocation => currentLocation.toLowerCase().startsWith('/overview'),
      },
      {
        path: '/organisation',
        component: OrganisationScene,
        exact: false,
        menuName: 'myOrganisation',
      },
      {
        path: '/community',
        menuName: 'myCommunity',
        exact: false,
        component: CommunityScene,
        hasRight: 'COMMUNITYMEMBERS.MANAGE.COMMUNITY',
      },
      {
        path: '/mgmt',
        menuName: 'management',
        hasFeature: 'PLATFORMMGMT',
        routes: [
          ...organisationsRoutes,
          ...organisationRolesRoutes,
          ...communitiesRoutes,
          ...identificationCodeTypesRoutes,
          ...relationTypesRoutes,
          ...themeLookupRoutes,
          ...appsRoutes,
          ...suiteRoutes,
        ],
      },
    ],
  },
];

export default routes;
